/**
 * @file Purchase Album Checkout Success container.
 */

import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeQuery } from '../../graphql/queries/account';
import { AlbumDataWithParentAndSubscription } from '../../graphql/queries/albums';
import PurchaseAlbumCheckoutSuccess from '../../components/purchase/PurchaseAlbumCheckoutSuccess';

const withUserData = graphql(MeQuery, {
  options: ({ match }) => ({
    variables: {
      albumId: match.params.albumId,
    },
  }),
  props: ({ data: { me, loading } }) => ({
    account: me,
    loading,
  }),
});

const withAlbumData = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album } }) => ({
    album,
  }),
});

const mapStateToProps = ({ purchaseAlbum }) => ({
  purchasedUrl: purchaseAlbum.purchasedUrl,
});

export default compose(
  withRouter,
  withUserData,
  withAlbumData,
  connect(mapStateToProps, null),
)(PurchaseAlbumCheckoutSuccess);
